// extracted by mini-css-extract-plugin
export default {"content":"DeadlineCell-module__content__y-B-P","date":"DeadlineCell-module__date__8QdJL","zone":"DeadlineCell-module__zone__d4rMQ","expired":"DeadlineCell-module__expired__SwlMQ"};